export const RESET = 'CATEGORY_UPDATE_RESET'
export const SET_ERROR = 'CATEGORY_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'CATEGORY_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'CATEGORY_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'CATEGORY_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'CATEGORY_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'CATEGORY_UPDATE_UPDATE_RETRIEVED'
export const SET_FILES = 'CATEGORY_UPDATE_FILES'
